import { addCallback } from '../lib/teact/teactn';

import type { GlobalState } from '../global/types';

import { selectChat, selectCurrentMessageList } from '../global/selectors';
import { IS_SHELL } from './browser/shellContainer';
import { callEventChatCloseNative, callEventChatOpenNative, callEventChatReadNative } from './nativeBridge';

let openChatId: string | undefined;
let readReportedFor: string | undefined;

function isChatRead(global: GlobalState, chatId: string) {
  const chat = selectChat(global, chatId);
  if (!chat) return false;

  return !chat.unreadCount && !chat.hasUnreadMark;
}

function onGlobalChange(global: GlobalState) {
  const isReady = global.authState === 'authorizationStateReady';
  const chatId = isReady ? selectCurrentMessageList(global)?.chatId : undefined;

  if (chatId !== openChatId) {
    if (openChatId) callEventChatCloseNative(openChatId);
    openChatId = chatId;
    readReportedFor = undefined;
    if (chatId) callEventChatOpenNative(chatId);
  }

  if (!openChatId) return;

  if (isChatRead(global, openChatId)) {
    if (readReportedFor !== openChatId) {
      readReportedFor = openChatId;
      callEventChatReadNative(openChatId);
    }
  } else {
    readReportedFor = undefined;
  }
}

export function initShellChatState() {
  if (!IS_SHELL) return;

  addCallback(onGlobalChange);
}
